(function () {
  // HLOTTO: order of the design photos in Shopify admin > Media (left to right).
  // Women's Statement Collection: 1 She Did, 2 Awesome Panda, 3 Blue Moon, 4 Positivity, 5 Spider Hunting.
  // If a design opens the wrong photo, just reorder these names to match your Media order.
  var HL_PHOTO_ORDER = ['she did', 'awesome panda', 'blue moon', 'positivity', 'spider hunting'];
  function hlOrderIndex(baseWords) {
    var n = (baseWords || '').trim();
    return HL_PHOTO_ORDER.indexOf(n);
  }
  var header = document.querySelector('.site-header');
  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.getElementById('site-nav');
  var wide = window.matchMedia('(min-width: 901px)');
  var backdrop = document.createElement('div');
  backdrop.className = 'nav-backdrop';
  document.body.appendChild(backdrop);

  function setMenu(open) {
    if (!header || !toggle) return;
    header.classList.toggle('nav-open', open);
    backdrop.classList.toggle('is-on', open);
    document.documentElement.classList.toggle('nav-lock', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    if (!open && nav) {
      nav.querySelectorAll('.has-sub.open').forEach(function (li) {
        li.classList.remove('open');
        var a = li.querySelector('a');
        if (a) a.setAttribute('aria-expanded', 'false');
      });
    }
  }
  if (header && toggle) {
    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      setMenu(!header.classList.contains('nav-open'));
    });
    backdrop.addEventListener('click', function () { setMenu(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && header.classList.contains('nav-open')) { setMenu(false); toggle.focus(); }
    });
    // tapping a normal link closes the menu; resizing to laptop resets it
    if (nav) nav.addEventListener('click', function (e) {
      var a = e.target.closest('a');
      if (a && !a.parentElement.classList.contains('has-sub')) setMenu(false);
      else if (a && a.parentElement.classList.contains('has-sub') && a.getAttribute('href') === '#') e.preventDefault();
    });
    var onResize = function () { if (wide.matches) setMenu(false); };
    if (wide.addEventListener) wide.addEventListener('change', onResize); else wide.addListener(onResize);
  }

  // dropdown parents (Catalog): click toggles on every screen size
  // laptop = floating dropdown (hover also works), phone/tablet = accordion inside the menu
  document.querySelectorAll('.has-sub > a').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var li = a.parentElement;
      var open = li.classList.toggle('open');
      a.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.has-sub.open').forEach(function (li) {
      if (wide.matches && !li.contains(e.target)) {
        li.classList.remove('open');
        var a = li.querySelector('a');
        if (a) a.setAttribute('aria-expanded', 'false');
      }
    });
  });

  var sort = document.querySelector('[data-sort]');
  if (sort) {
    var sgrid = document.querySelector('[data-sort-grid]');
    var sortCards = sgrid ? Array.prototype.slice.call(sgrid.querySelectorAll('.card')) : [];
    sortCards.forEach(function (c, i) { c.setAttribute('data-pos', i); });
    var initialSort = sort.value;
    // custom dropdown (rounded pill + dark menu) built on top of the real <select>
    (function () {
      var wrap = sort.parentNode;
      wrap.classList.add('sort-wrap--custom');
      var dd = document.createElement('div'); dd.className = 'sdd';
      var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'sdd__btn';
      btn.setAttribute('aria-haspopup', 'listbox'); btn.setAttribute('aria-expanded', 'false');
      var lab = document.createElement('span'); btn.appendChild(lab);
      var list = document.createElement('ul'); list.className = 'sdd__list'; list.setAttribute('role', 'listbox');
      var items = [];
      Array.prototype.forEach.call(sort.options, function (o) {
        var li = document.createElement('li'); li.setAttribute('role', 'option');
        li.textContent = o.text.replace(', ', ': '); li.setAttribute('data-v', o.value);
        li.addEventListener('click', function () {
          sort.value = o.value; sync(); close();
          sort.dispatchEvent(new Event('change', { bubbles: true }));
        });
        list.appendChild(li); items.push(li);
      });
      function sync() {
        items.forEach(function (li) { var on = li.getAttribute('data-v') === sort.value; li.classList.toggle('is-on', on); li.setAttribute('aria-selected', on); if (on) lab.textContent = li.textContent; });
      }
      function close() { dd.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }
      btn.addEventListener('click', function (e) { e.stopPropagation(); var o = dd.classList.toggle('is-open'); btn.setAttribute('aria-expanded', o); });
      document.addEventListener('click', function (e) { if (!dd.contains(e.target)) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
      dd.appendChild(btn); dd.appendChild(list); wrap.appendChild(dd); sync();
    })();
    // load every product photo ahead of time so re-ordering shows them instantly
    var warmSort = function () { sortCards.forEach(function (c) { var im = c.querySelector('img'); if (im) im.loading = 'eager'; }); };
    if ('requestIdleCallback' in window) requestIdleCallback(warmSort, { timeout: 1500 }); else setTimeout(warmSort, 800);
    ['pointerdown', 'focus', 'touchstart'].forEach(function (ev) { sort.addEventListener(ev, warmSort, { once: true, passive: true }); });
    sort.addEventListener('change', function () {
      var v = sort.value;
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', v);
      url.searchParams.delete('page');
      var single = sgrid && parseInt(sgrid.getAttribute('data-pages'), 10) <= 1;
      // Instant, in-page sort (no reload) whenever every product is on this page
      if (single && v !== 'best-selling' && (v !== 'manual' || initialSort === 'manual')) {
        var num = function (el, k) { return parseFloat(el.getAttribute(k)) || 0; };
        var cmp = {
          'manual': function (a, b) { return num(a, 'data-pos') - num(b, 'data-pos'); },
          'created-descending': function (a, b) { return num(b, 'data-created') - num(a, 'data-created'); },
          'price-ascending': function (a, b) { return num(a, 'data-price') - num(b, 'data-price'); },
          'price-descending': function (a, b) { return num(b, 'data-price') - num(a, 'data-price'); }
        }[v];
        if (cmp) {
          var frag = document.createDocumentFragment();
          sortCards.slice().sort(cmp).forEach(function (c) { frag.appendChild(c); });
          sgrid.appendChild(frag);
          if (window.hlottoLoader) { window.hlottoLoader.show(); setTimeout(window.hlottoLoader.hide, 500); }
          try { history.replaceState(null, '', url.toString()); } catch (e) {}
          return;
        }
      }
      if (window.hlottoLoader) window.hlottoLoader.show();
      window.location.href = url.toString();
    });
  }

  document.querySelectorAll('form.product-form').forEach(function (form) {
    var data = JSON.parse(form.querySelector('script[type="application/json"]').textContent);
    var idInput = form.querySelector('[name="id"]');
    var btn = form.querySelector('[data-add]');
    var priceEl = document.querySelector('[data-price]');
    var wa = document.querySelector('[data-wa-order]');
    var fmt = new Intl.NumberFormat(undefined, { style: 'currency', currency: data.currency });

    var gallery = document.querySelector('.gallery');
    var origImgs = gallery ? Array.prototype.slice.call(gallery.querySelectorAll('img')) : [];
    var isMobile = window.matchMedia('(max-width: 900px)');
    // download the other colour photos in the background so switching is instant
    if (origImgs.length > 1 && !(navigator.connection && navigator.connection.saveData)) {
      var warmGallery = function () { origImgs.forEach(function (im) { im.loading = 'eager'; }); };
      if ('requestIdleCallback' in window) requestIdleCallback(warmGallery, { timeout: 2000 });
      else setTimeout(warmGallery, 1200);
    }
    var words = function (t) { return ' ' + (t || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim() + ' '; };

    // names of the colour / design option groups (so Size never picks an image)
    var colourPos = [];
    form.querySelectorAll('[data-option-group]').forEach(function (g, i) {
      var lg = g.querySelector('legend');
      if (lg && /colo|design|print|pattern/i.test(lg.textContent)) colourPos.push(i);
    });

    // remember which group (Color or Design Name) the customer touched last
    var lastPos = -1;
    form.addEventListener('change', function (e) {
      form.querySelectorAll('[data-option-group]').forEach(function (g, i) { if (g.contains(e.target)) lastPos = i; });
    });

    // true when changing this group really changes the variant photo
    function drives(pos, chosen) {
      var group = form.querySelectorAll('[data-option-group]')[pos];
      var vals = Array.prototype.map.call(group.querySelectorAll('input[type="radio"]'), function (r) { return r.value; });
      var cur = data.variants.find(function (x) { return x.options.join('|') === chosen.join('|'); });
      var curId = cur && cur.featured_image ? cur.featured_image.id : null;
      if (!curId) return false;
      return vals.some(function (val) {
        if (val === chosen[pos]) return false;
        var probe = chosen.slice(); probe[pos] = val;
        var o = data.variants.find(function (x) { return x.options.join('|') === probe.join('|'); });
        return o && o.featured_image && o.featured_image.id !== curId;
      });
    }

    function findImage(imgs, v, chosen) {
      var byId = function (id) {
        return imgs.find(function (im) { return String(im.dataset.imageId) === String(id); });
      };
      // the group just clicked is checked first, so clicking a Design changes the photo too
      var order = colourPos.slice().sort(function (a, b) { return (b === lastPos) - (a === lastPos); });
      var t = null;
      // 0) the clicked group (e.g. Design Name) doesn't change the variant photo: find the photo by name
      var clickedLg = lastPos > -1 ? form.querySelectorAll('[data-option-group]')[lastPos].querySelector('legend') : null;
      var clickedIsDesign = !!clickedLg && /design|print|pattern/i.test(clickedLg.textContent);
      if (lastPos > -1 && (clickedIsDesign || !drives(lastPos, chosen))) {
        var need = colourPos.map(function (p) { return words(chosen[p]); });
        var pickBy = function (keys) {
          var hits = imgs.filter(function (im) {
            var file = (im.currentSrc || im.src || '').split('?')[0].split('/').pop();
            var txt = words(im.alt) + words(file);
            return keys.every(function (k) { return txt.indexOf(k) !== -1; });
          });
          var txtOf = function (im) { return words(im.alt) + words(((im.currentSrc || im.src || '').split('?')[0].split('/').pop())); };
          hits.sort(function (a, b) { return txtOf(a).length - txtOf(b).length; });
          return hits[0] || null;
        };
        var colVals = [];
        form.querySelectorAll('[data-option-group]').forEach(function (g, gi) {
          var lg = g.querySelector('legend');
          if (lg && /colo/i.test(lg.textContent) && !/design|print|pattern/i.test(lg.textContent)) {
            g.querySelectorAll('input[type="radio"]').forEach(function (r) { colVals.push(r.value); });
          }
        });
        colVals.sort(function (a, b) { return b.length - a.length; });
        var base = function (val) {
          var w = words(val);
          for (var n = 0; n < colVals.length; n++) {
            var c = words(colVals[n]);
            if (w.length > c.length && w.slice(-c.length) === c) return w.slice(0, w.length - c.length + 1);
          }
          return w;
        };
        t = pickBy(need) || pickBy([words(chosen[lastPos])]) || pickBy([base(chosen[lastPos])]);
        if (!t) { var oi = hlOrderIndex(base(chosen[lastPos])); if (oi > -1) t = origImgs[oi] || null; }
        // Design Name chips: photos are in the same order as the design chips (colour suffix ignored)
        if (!t && clickedIsDesign) {
          var dgrp = form.querySelectorAll('[data-option-group]')[lastPos];
          var dvals = Array.prototype.map.call(dgrp.querySelectorAll('input[type="radio"]'), function (r) { return r.value; });
          var bases = [];
          dvals.forEach(function (dv) { var b = base(dv).trim(); if (bases.indexOf(b) < 0) bases.push(b); });
          var bi = bases.indexOf(base(chosen[lastPos]).trim());
          if (bi > -1 && origImgs.length >= bases.length) t = origImgs[bi];
        }
        // colour chips only: photos are in the same order as the chips (extra photos may follow at the end)
        if (!t && colourPos.length === 1 && !clickedIsDesign) {
          var cg = form.querySelectorAll('[data-option-group]')[colourPos[0]];
          var cvals = Array.prototype.map.call(cg.querySelectorAll('input[type="radio"]'), function (r) { return r.value; });
          var ci = cvals.indexOf(chosen[colourPos[0]]);
          if (ci > -1 && origImgs.length >= cvals.length) t = origImgs[ci];
        }
        // the photo linked to this variant in Shopify admin (only when it really changes between the chips)
        if (!t && v && v.featured_image && drives(lastPos, chosen)) t = byId(v.featured_image.id);
        // no photo matches this name: keep the current photo instead of showing a wrong one
        if (!t) return null;
      }
      // 1) the exact variant (colour + design + size) has its own image
      if (!t && v && v.featured_image) t = byId(v.featured_image.id);
      // 2a) same colour + design in another size
      if (!t) {
        var combo = data.variants.find(function (x) {
          return colourPos.every(function (p) { return x.options[p] === chosen[p]; }) && x.featured_image && byId(x.featured_image.id);
        });
        if (combo) t = byId(combo.featured_image.id);
      }
      // 2b) any variant that shares the clicked colour or design
      if (!t) {
        order.forEach(function (pos) {
          if (t) return;
          var other = data.variants.find(function (x) {
            return x.options[pos] === chosen[pos] && x.featured_image && byId(x.featured_image.id);
          });
          if (other) t = byId(other.featured_image.id);
        });
      }
      // 3) fallback: colour / design name appears in the image alt text or file name
      if (!t) {
        order.forEach(function (pos) {
          if (t) return;
          var key = words(chosen[pos]);
          var hits = imgs.filter(function (im) {
            var file = (im.currentSrc || im.src || '').split('?')[0].split('/').pop();
            return words(im.alt).indexOf(key) !== -1 || words(file).indexOf(key) !== -1;
          });
          // prefer the most specific match (e.g. "Green" over "Olive Green" photo)
          hits.sort(function (a, b) { return words(a.alt).length - words(b.alt).length; });
          if (hits.length) t = hits[0];
        });
      }
      // 4) last fallback: photos are in the same order as the colour chips
      if (!t && colourPos.length === 1) {
        order.forEach(function (pos) {
          if (t) return;
          var group = form.querySelectorAll('[data-option-group]')[pos];
          var vals = Array.prototype.map.call(group.querySelectorAll('input[type="radio"]'), function (r) { return r.value; });
          var idx = vals.indexOf(chosen[pos]);
          if (idx > -1 && origImgs.length >= vals.length) t = origImgs[idx];
        });
      }
      return t;
    }

    // bring the selected colour / design image to the front of the gallery
    function showDesign(v, chosen, animate) {
      if (!gallery) return;
      var imgs = Array.prototype.slice.call(gallery.querySelectorAll('img'));
      if (!imgs.length || !colourPos.length) return;
      // Size (or any non colour/design option) must never change the photo
      if (lastPos > -1 && colourPos.indexOf(lastPos) < 0) return;
      var target = findImage(imgs, v, chosen);
      if (!target) {
        if (window.console) console.info('HLOTTO: no photo found for "' + colourPos.map(function (p) { return chosen[p]; }).join(' / ') + '" (' + imgs.length + ' photos on this product). Assign it as a variant image in Shopify admin.');
        return;
      }
      if (target !== gallery.firstElementChild) {
        gallery.insertBefore(target, gallery.firstElementChild);
        target.loading = 'eager';
        gallery.scrollLeft = 0;
        if (animate) {
          target.classList.remove('is-swapped');
          void target.offsetWidth;
          target.classList.add('is-swapped');
        }
      }
      // phone: if the photo is scrolled out of view, bring it back so the customer sees the colour change
      if (animate && isMobile.matches) {
        var r = gallery.getBoundingClientRect();
        if (r.bottom < window.innerHeight * 0.35 || r.top > window.innerHeight * 0.6) {
          gallery.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    }
    var firstRun = true;

    function update() {
      var chosen = [];
      form.querySelectorAll('[data-option-group]').forEach(function (g) {
        var c = g.querySelector('input:checked');
        chosen.push(c ? c.value : null);
      });
      if (!chosen.length) { return; }
      if (wa) {
        wa.href = wa.dataset.base + encodeURIComponent(wa.dataset.text + ' (' + chosen.join(' / ') + ')');
      }
      var v = data.variants.find(function (x) { return x.options.join('|') === chosen.join('|'); });
      showDesign(v, chosen, !firstRun);
      firstRun = false;
      if (!v) { btn.disabled = true; btn.textContent = btn.dataset.unavailable; return; }
      idInput.value = v.id;
      btn.disabled = !v.available;
      btn.textContent = v.available ? btn.dataset.add : btn.dataset.sold;
      if (priceEl) priceEl.textContent = fmt.format(v.price / 100);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    form.addEventListener('change', update);
    update();
  });

  // collection cards: clicking a colour / design chip swaps that card's image instantly (no page change)
  var swCache = {};
  var saveData = navigator.connection && navigator.connection.saveData;
  function warm(url) {
    if (!url || swCache[url]) return;
    var im = new Image();
    im.decoding = 'async';
    im.src = url;
    swCache[url] = im;
  }
  function warmCard(card) {
    if (saveData || card.dataset.warmed) return;
    card.dataset.warmed = '1';
    var urls = [];
    card.querySelectorAll('[data-swatch][data-image]').forEach(function (b) { urls.push(b.dataset.image); });
    try {
      JSON.parse(card.dataset.variants || '[]').forEach(function (v) { if (v.i) urls.push(v.i); });
    } catch (err) {}
    urls.filter(function (u, i) { return u && urls.indexOf(u) === i; }).forEach(function (u, i) {
      setTimeout(function () { warm(u); }, i * 60);
    });
  }
  var cards = document.querySelectorAll('.card');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { warmCard(en.target); io.unobserve(en.target); }
      });
    }, { rootMargin: '400px 0px' });
    cards.forEach(function (c) { if (c.querySelector('[data-swatch]')) io.observe(c); });
  } else {
    window.addEventListener('load', function () { cards.forEach(warmCard); });
  }
  // touch / hover = the customer is about to pick a colour: make sure everything is loading
  ['touchstart', 'pointerenter', 'focusin'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      var c = e.target.closest && e.target.closest('.card');
      if (c) warmCard(c);
    }, { passive: true, capture: true });
  });

  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-swatch]');
    if (!sw) return;
    e.preventDefault();
    var card = sw.closest('.card');
    if (!card) return;
    // make this chip the active one inside its own group (Color or Design Name)
    var group = sw.dataset.group;
    card.querySelectorAll('[data-swatch]').forEach(function (b) {
      if (b.dataset.group === group) b.classList.toggle('is-active', b === sw);
    });
    // what is selected in every group right now
    var sel = {};
    card.querySelectorAll('[data-swatch].is-active').forEach(function (b) { sel[b.dataset.group] = b.dataset.value; });
    // find the variant that has this exact colour + design together
    var variants = [];
    try { variants = JSON.parse(card.dataset.variants || '[]'); } catch (err) {}
    var match = variants.find(function (v) {
      return Object.keys(sel).every(function (g) { return v.o[g] === sel[g]; });
    });
    var words = function (t) { return ' ' + (t || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim() + ' '; };
    // does this group (Color / Design Name) really change the variant photo?
    var drives = false;
    if (match && match.i) {
      card.querySelectorAll('[data-swatch][data-group="' + group + '"]').forEach(function (c) {
        if (c === sw) return;
        var other = variants.find(function (v) {
          return Object.keys(sel).every(function (g) { return v.o[g] === (g === group ? c.dataset.value : sel[g]); });
        });
        if (other && other.i && other.i !== match.i) drives = true;
      });
    }
    var url;
    var photos = [];
    try { photos = JSON.parse(card.dataset.images || '[]'); } catch (err) {}
    var isDesignChip = /design|print|pattern/i.test(sw.dataset.groupName || '');
    var colourVals = [];
    card.querySelectorAll('[data-swatch]').forEach(function (b) {
      if (!/design|print|pattern/i.test(b.dataset.groupName || '')) colourVals.push(b.dataset.value);
    });
    colourVals = colourVals.filter(function (v, i) { return colourVals.indexOf(v) === i; })
      .sort(function (a, b) { return b.length - a.length; });
    // "Spider Hunting Dark Pink" -> "Spider Hunting" (design name without the colour tacked on the end)
    var baseName = function (val) {
      var w = words(val);
      for (var n = 0; n < colourVals.length; n++) {
        var c = words(colourVals[n]);
        if (w.length > c.length && w.slice(-c.length) === c) return w.slice(0, w.length - c.length + 1);
      }
      return w;
    };
    var byName = function (val) {
      var tries = [words(val), baseName(val)];
      for (var k = 0; k < tries.length; k++) {
        var key = tries[k];
        var hits = photos.filter(function (im) { return words(im.t).indexOf(key) !== -1; });
        hits.sort(function (a, b) { return words(a.t).length - words(b.t).length; });
        if (hits[0]) return hits[0];
      }
      var oi = hlOrderIndex(baseName(val));
      return oi > -1 ? (photos[oi] || null) : null;
    };
    var picked = null;
    if (isDesignChip) {
      // clicked a design name: the photo that carries THIS design's name wins
      picked = byName(sw.dataset.value);
    } else {
      // clicked a colour: keep showing the currently chosen design's photo if colour has no photo of its own
      picked = (drives && match && match.i) ? null : (photos.find(function (im) {
        return Object.keys(sel).every(function (g) { return words(im.t).indexOf(words(sel[g])) !== -1; });
      }) || byName(sw.dataset.value));
      if (!picked && !drives) {
        card.querySelectorAll('[data-swatch].is-active').forEach(function (b) {
          if (!picked && /design|print|pattern/i.test(b.dataset.groupName || '')) picked = byName(b.dataset.value);
        });
      }
    }
    if (picked) url = picked.i;
    else if (match && match.i) url = match.i;          // photo linked to that exact variant in Shopify admin
    else url = sw.dataset.image || '';
    if (!picked && window.console) console.info('HLOTTO: no photo named \"' + sw.dataset.value + '\". Put the design name in the photo alt text, or link the photo to the variant in Shopify admin.');
    if (/[?&]hldebug=1/.test(location.search)) {
      var fn = function (u) { return (u || '').split('?')[0].split('/').pop() || '(none)'; };
      var box = document.getElementById('hl-debug');
      if (!box) {
        box = document.createElement('pre');
        box.id = 'hl-debug';
        box.style.cssText = 'position:fixed;left:0;right:0;bottom:0;max-height:55vh;overflow:auto;margin:0;padding:10px;background:#000;color:#0f0;font:11px/1.35 monospace;z-index:99999;white-space:pre-wrap';
        document.body.appendChild(box);
      }
      box.textContent = 'CLICKED: ' + sw.dataset.groupName + ' = ' + sw.dataset.value +
        '\nSELECTED: ' + JSON.stringify(sel) +
        '\nVARIANT FOUND: ' + (match ? match.id : 'NONE') + '  its photo: ' + fn(match && match.i) +
        '\nPHOTO BY NAME: ' + (picked ? fn(picked.i) : 'NONE') +
        '\nSHOWN: ' + fn(url) +
        '\n\nALL PHOTOS (alt + file name):\n' + photos.map(function (im, n) { return (n + 1) + '. ' + im.t.trim() + '  ->  ' + fn(im.i); }).join('\n') +
        '\n\nVARIANT PHOTOS:\n' + variants.map(function (v) { return v.o.join(' / ') + '  ->  ' + fn(v.i); }).join('\n');
    }
    var variantId = (match && match.id) || sw.dataset.variant;
    // links open the product page with this choice already selected
    card.querySelectorAll('[data-card-link]').forEach(function (a) {
      a.href = variantId ? a.dataset.base + '?variant=' + variantId : a.dataset.base;
    });
    var img = card.querySelector('[data-card-img]');
    if (!img || !url) return;
    card.dataset.pending = url;
    var apply = function () {
      if (card.dataset.pending !== url) return; // customer already clicked something else
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.loading = 'eager';
      img.src = url;
      img.classList.remove('is-loading');
      img.classList.remove('is-swapped');
      void img.offsetWidth;
      img.classList.add('is-swapped');
    };
    var pre = swCache[url];
    if (pre && pre.complete && pre.naturalWidth) {
      apply();                       // already downloaded: instant
    } else {
      img.classList.add('is-loading'); // show feedback right away while it downloads
      var tmp = pre || new Image();
      swCache[url] = tmp;
      tmp.addEventListener('load', apply, { once: true });
      tmp.addEventListener('error', apply, { once: true });
      if (!pre) { tmp.decoding = 'async'; tmp.src = url; }
      else if (pre.complete) { apply(); }
    }
  });

  // catalog filter on the all-products page (?type=Polo%20T-Shirt)
  var grid = document.querySelector('[data-filter-grid]');
  if (grid) {
    var norm = function (t) { return (t || '').toLowerCase().replace(/[^a-z0-9]/g, ''); };
    var same = function (a, b) { return a && b && (a === b || a === b + 's' || b === a + 's'); };
    var titleEl = document.querySelector('[data-filter-title]');
    var emptyEl = document.querySelector('[data-filter-empty]');
    var pills = document.querySelectorAll('[data-pill]');
    var apply = function (type) {
      var n = norm(type), shown = 0;
      grid.querySelectorAll('.card').forEach(function (c) {
        var ok = true;
        if (n) {
          ok = same(norm(c.dataset.type), n);
          if (!ok) (c.dataset.tags || '').split('|').forEach(function (tg) { if (same(norm(tg), n)) ok = true; });
        }
        c.hidden = !ok;
        if (ok) shown++;
      });
      if (emptyEl) emptyEl.hidden = shown > 0;
      var countEl = document.querySelector('[data-product-count]');
      if (countEl) countEl.textContent = shown + (shown === 1 ? ' product' : ' products');
      if (titleEl) titleEl.textContent = type || titleEl.dataset.default;
      pills.forEach(function (p) {
        p.classList.toggle('is-active', n ? norm(p.dataset.pill) === n : p.dataset.pill === 'all');
      });
    };
    apply(new URLSearchParams(window.location.search).get('type'));
    pills.forEach(function (p) {
      p.addEventListener('click', function (e) {
        var isAll = p.dataset.pill === 'all';
        if (!isAll && !p.dataset.type) return;
        e.preventDefault();
        var url = new URL(window.location.href);
        if (isAll) url.searchParams.delete('type'); else url.searchParams.set('type', p.dataset.type);
        window.history.replaceState({}, '', url.toString());
        apply(isAll ? '' : p.dataset.type);
      });
    });
  }
})();

/* ===== product gallery: arrows, counter, hover zoom, full screen zoom viewer ===== */
(function () {
  var wrap = document.querySelector('[data-gallery-wrap]');
  if (!wrap) return;
  var gallery = wrap.querySelector('[data-gallery]');
  var prev = wrap.querySelector('[data-g-prev]');
  var next = wrap.querySelector('[data-g-next]');
  var count = wrap.querySelector('[data-g-count]');
  var zoomBox = wrap.querySelector('[data-g-zoom]');

  function slides() { return Array.prototype.slice.call(gallery.children); }
  function step() {
    var k = slides();
    if (k.length < 2) return gallery.clientWidth;
    return k[1].offsetLeft - k[0].offsetLeft;
  }
  function current() {
    var k = slides(), max = gallery.scrollWidth - gallery.clientWidth;
    if (!k.length) return 0;
    if (max > 0 && gallery.scrollLeft >= max - 3) return k.length - 1;
    return Math.max(0, Math.min(k.length - 1, Math.round(gallery.scrollLeft / step())));
  }
  function update() {
    var k = slides(), i = current();
    if (count) count.textContent = (i + 1) + ' / ' + Math.max(k.length, 1);
    if (prev) prev.disabled = i <= 0;
    if (next) next.disabled = i >= k.length - 1;
  }
  function goTo(i) {
    var k = slides();
    i = Math.max(0, Math.min(k.length - 1, i));
    gallery.scrollTo({ left: k[i].offsetLeft - k[0].offsetLeft, behavior: 'smooth' });
  }
  gallery.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
  window.addEventListener('resize', update);
  if (prev) prev.addEventListener('click', function () { goTo(current() - 1); });
  if (next) next.addEventListener('click', function () { goTo(current() + 1); });
  update();

  /* ---- hover zoom (laptop / mouse) ---- */
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  var ZOOM = 2.4;
  function bigSrc(img) {
    var ss = img.getAttribute('srcset') || '';
    var re = /(\S+)\s+(\d+)w/g, m, best = null, bw = 0;
    while ((m = re.exec(ss))) { if (+m[2] > bw) { bw = +m[2]; best = m[1]; } }
    return best || img.currentSrc || img.src;
  }
  function hoverMove(e) {
    if (!canHover.matches) return;
    var img = e.target.closest ? e.target.closest('img') : null;
    if (!img || !zoomBox) { hideZoom(); return; }
    var r = img.getBoundingClientRect(), w = wrap.getBoundingClientRect();
    var x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
    if (!zoomBox.classList.contains('is-on') || zoomBox.dataset.src !== img.currentSrc) {
      zoomBox.dataset.src = img.currentSrc;
      zoomBox.style.backgroundImage = 'url("' + bigSrc(img) + '")';
    }
    var nw = img.naturalWidth || r.width, nh = img.naturalHeight || r.height;
    var sc = Math.max(r.width / nw, r.height / nh) * ZOOM;
    zoomBox.style.left = (r.left - w.left) + 'px';
    zoomBox.style.top = (r.top - w.top) + 'px';
    zoomBox.style.width = r.width + 'px';
    zoomBox.style.height = r.height + 'px';
    zoomBox.style.backgroundSize = (nw * sc) + 'px ' + (nh * sc) + 'px';
    zoomBox.style.backgroundPosition = (x * 100) + '% ' + (y * 100) + '%';
    zoomBox.classList.add('is-on');
  }
  function hideZoom() { if (zoomBox) zoomBox.classList.remove('is-on'); }
  gallery.addEventListener('mousemove', hoverMove);
  gallery.addEventListener('mouseleave', hideZoom);
  gallery.addEventListener('scroll', hideZoom, { passive: true });

  /* ---- full screen viewer ---- */
  var lb = document.createElement('div');
  lb.className = 'lb';
  lb.setAttribute('role', 'dialog');
  lb.setAttribute('aria-modal', 'true');
  lb.setAttribute('aria-label', 'Product image viewer');
  lb.innerHTML =
    '<div class="lb__stage"><img class="lb__img" alt="" draggable="false"></div>' +
    '<span class="lb__count"></span>' +
    '<button type="button" class="lb__btn lb__close" aria-label="Close">&#10005;</button>' +
    '<button type="button" class="lb__btn lb__prev" aria-label="Previous image">&#8249;</button>' +
    '<button type="button" class="lb__btn lb__next" aria-label="Next image">&#8250;</button>' +
    '<button type="button" class="lb__btn lb__zoom" data-z="out" aria-label="Zoom out">&minus;</button>' +
    '<button type="button" class="lb__btn lb__zoom" data-z="in" aria-label="Zoom in">+</button>' +
    '<div class="lb__tip">Tap to zoom, drag to move, pinch for more</div>';
  document.body.appendChild(lb);
  var stage = lb.querySelector('.lb__stage');
  var lbImg = lb.querySelector('.lb__img');
  var lbCount = lb.querySelector('.lb__count');
  var list = [], idx = 0, sc = 1, tx = 0, ty = 0, MAX = 5;
  var tip = lb.querySelector('.lb__tip');
  if (canHover.matches) tip.textContent = 'Click to zoom, drag to move, scroll to zoom more';

  function apply(anim) {
    lbImg.classList.toggle('is-anim', !!anim);
    lbImg.classList.toggle('is-zoomed', sc > 1.01);
    lbImg.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + sc + ')';
  }
  function clamp() {
    var mx = Math.max(0, (lbImg.offsetWidth * sc - stage.clientWidth) / 2);
    var my = Math.max(0, (lbImg.offsetHeight * sc - stage.clientHeight) / 2);
    tx = Math.max(-mx, Math.min(mx, tx));
    ty = Math.max(-my, Math.min(my, ty));
  }
  function zoomAt(ns, cx, cy, anim) {
    ns = Math.max(1, Math.min(MAX, ns));
    var b = stage.getBoundingClientRect();
    var px = cx - (b.left + b.width / 2), py = cy - (b.top + b.height / 2);
    var k = ns / sc;
    tx = px - k * (px - tx);
    ty = py - k * (py - ty);
    sc = ns;
    if (sc <= 1.001) { sc = 1; tx = 0; ty = 0; }
    clamp();
    apply(anim);
  }
  function show(i) {
    idx = (i + list.length) % list.length;
    sc = 1; tx = 0; ty = 0; apply(false);
    lbImg.src = list[idx].src;
    lbImg.alt = list[idx].alt;
    lbCount.textContent = (idx + 1) + ' / ' + list.length;
    var multi = list.length > 1;
    lb.querySelector('.lb__prev').style.visibility = multi ? '' : 'hidden';
    lb.querySelector('.lb__next').style.visibility = multi ? '' : 'hidden';
    lbCount.style.display = multi ? '' : 'none';
  }
  function openAt(img) {
    var imgs = Array.prototype.slice.call(gallery.querySelectorAll('img'));
    list = imgs.map(function (el) { return { src: bigSrc(el), alt: el.alt || '', el: el }; });
    var n = imgs.indexOf(img);
    lb.classList.add('is-open');
    document.body.classList.add('lb-open');
    show(n < 0 ? 0 : n);
  }
  function close() {
    lb.classList.remove('is-open');
    document.body.classList.remove('lb-open');
    var t = list[idx] && list[idx].el;
    if (t) { var k = slides(); var j = k.indexOf(t); if (j > -1) goTo(j); }
  }
  wrap.addEventListener('click', function (e) {
    var img = e.target.closest ? e.target.closest('img') : null;
    if (img && gallery.contains(img)) { hideZoom(); openAt(img); }
  });
  var zb = document.createElement('button');
  zb.type = 'button';
  zb.className = 'g-zoombtn';
  zb.setAttribute('aria-label', 'Zoom image');
  zb.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5L21 21M10.5 7.5v6M7.5 10.5h6"/></svg>';
  wrap.appendChild(zb);
  zb.addEventListener('click', function (e) {
    e.stopPropagation();
    var imgs = Array.prototype.slice.call(gallery.querySelectorAll('img'));
    if (imgs.length) openAt(imgs[Math.min(current(), imgs.length - 1)]);
  });
  lb.querySelector('.lb__close').addEventListener('click', close);
  lb.querySelector('.lb__prev').addEventListener('click', function () { show(idx - 1); });
  lb.querySelector('.lb__next').addEventListener('click', function () { show(idx + 1); });
  lb.querySelectorAll('.lb__zoom').forEach(function (b) {
    b.addEventListener('click', function () {
      var r = stage.getBoundingClientRect();
      zoomAt(sc * (b.getAttribute('data-z') === 'in' ? 1.6 : 1 / 1.6), r.left + r.width / 2, r.top + r.height / 2, true);
    });
  });
  document.addEventListener('keydown', function (e) {
    if (!lb.classList.contains('is-open')) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft') show(idx - 1);
    else if (e.key === 'ArrowRight') show(idx + 1);
    else if (e.key === '+' || e.key === '=') { var r = stage.getBoundingClientRect(); zoomAt(sc * 1.4, r.left + r.width / 2, r.top + r.height / 2, true); }
    else if (e.key === '-') { var r2 = stage.getBoundingClientRect(); zoomAt(sc / 1.4, r2.left + r2.width / 2, r2.top + r2.height / 2, true); }
  });
  // tap on the dark area (not on the picture) closes
  stage.addEventListener('click', function (e) { if (e.target === stage && !moved) close(); });

  /* mouse: wheel zoom, drag to pan, double click toggle */
  var drag = null, moved = false;
  stage.addEventListener('wheel', function (e) {
    e.preventDefault();
    zoomAt(sc * (e.deltaY < 0 ? 1.2 : 1 / 1.2), e.clientX, e.clientY, false);
  }, { passive: false });
  var touchedAt = 0;
  // click on the photo = zoom in at that spot, click again = zoom out; drag when zoomed = move around
  stage.addEventListener('mousedown', function (e) {
    if (e.button !== 0 || Date.now() - touchedAt < 700) return;
    drag = { x: e.clientX, y: e.clientY, tx: tx, ty: ty, onImg: e.target === lbImg }; moved = false; e.preventDefault();
  });
  window.addEventListener('mousemove', function (e) {
    if (!drag) return;
    var dx = e.clientX - drag.x, dy = e.clientY - drag.y;
    if (Math.abs(dx) + Math.abs(dy) > 4) moved = true;
    if (moved && sc > 1.01) { tx = drag.tx + dx; ty = drag.ty + dy; clamp(); apply(false); }
  });
  window.addEventListener('mouseup', function (e) {
    var d = drag; drag = null;
    if (d && !moved && d.onImg) zoomAt(sc > 1.05 ? 1 : 2.6, e.clientX, e.clientY, true);
    setTimeout(function () { moved = false; }, 0);
  });

  /* touch: pinch, double tap, pan when zoomed, swipe when not zoomed */
  var t0 = null, pinch = null, lastTap = 0, lastX = 0, lastY = 0, swipe = null;
  function dist(a, b) { return Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY); }
  stage.addEventListener('touchstart', function (e) {
    if (e.touches.length === 2) {
      pinch = { d: dist(e.touches[0], e.touches[1]), s: sc };
      swipe = null; t0 = null;
    } else if (e.touches.length === 1) {
      var t = e.touches[0];
      t0 = { x: t.clientX, y: t.clientY, tx: tx, ty: ty };
      swipe = sc <= 1.01 ? { x: t.clientX, y: t.clientY } : null;
    }
  }, { passive: true });
  stage.addEventListener('touchmove', function (e) {
    if (pinch && e.touches.length === 2) {
      e.preventDefault();
      var a = e.touches[0], b = e.touches[1];
      zoomAt(pinch.s * dist(a, b) / pinch.d, (a.clientX + b.clientX) / 2, (a.clientY + b.clientY) / 2, false);
    } else if (t0 && e.touches.length === 1 && sc > 1.01) {
      e.preventDefault();
      var t = e.touches[0];
      tx = t0.tx + (t.clientX - t0.x); ty = t0.ty + (t.clientY - t0.y);
      clamp(); apply(false);
    }
  }, { passive: false });
  stage.addEventListener('touchend', function (e) {
    touchedAt = Date.now();
    if (e.touches.length === 0) {
      var c = e.changedTouches[0];
      if (pinch) { pinch = null; t0 = null; return; }
      if (swipe && c) {
        var dx = c.clientX - swipe.x, dy = c.clientY - swipe.y;
        if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.4 && list.length > 1) {
          show(dx < 0 ? idx + 1 : idx - 1); swipe = null; t0 = null; lastTap = 0; return;
        }
        if (dy > 110 && Math.abs(dy) > Math.abs(dx) * 1.4) { close(); swipe = null; t0 = null; return; }
      }
      if (c && t0 && e.target === lbImg && Math.abs(c.clientX - t0.x) < 10 && Math.abs(c.clientY - t0.y) < 10) {
        zoomAt(sc > 1.05 ? 1 : 2.6, c.clientX, c.clientY, true);
      }
      t0 = null; swipe = null;
    } else if (e.touches.length === 1) {
      pinch = null;
      var t = e.touches[0];
      t0 = { x: t.clientX, y: t.clientY, tx: tx, ty: ty };
    }
  }, { passive: true });
})();

